module.exports = __webpack_public_path__ + "static/media/luke.0882aeee.jpg";